import React from "react";
import './about.css'
import ME from "../../assets/profile.png"
import useReveal from "../../hooks/useReveal";

const stats = [
    ["experience", "7+ years"],
    ["scale",      "Terabytes / day"],
    ["llms",       "120B-class fine-tuned"],
    ["mode",       "remote-first · async"],
];

const About = () => {
    const ref = useReveal();
    return (
        <section id="about">
            <h5>$ cat about.md</h5>
            <h2>About Me</h2>
            <div className="container reveal" ref={ref}>
                <div className="about__term term-window">
                    <div className="term-titlebar">
                        <span className="term-dot red"></span>
                        <span className="term-dot yellow"></span>
                        <span className="term-dot green"></span>
                        <span className="term-path">~/about.md</span>
                    </div>
                    <div className="about__body">
                        <div className="about__me">
                            <div className="about__me-image">
                                <img src={ME} alt="Sumit Kumar"/>
                            </div>
                        </div>

                        <div className="about__content">
                            <p className="mono about__cmd"><span className="txt-green">$</span> stats</p>
                            <div className="about__stats mono">
                                {stats.map(([k, v]) => (
                                    <div className="about__stat" key={k}>
                                        <span className="about__stat-key">{k}</span>
                                        <span className="about__stat-sep">:</span>
                                        <span className="about__stat-val">{v}</span>
                                    </div>
                                ))}
                            </div>

                            <p className="mono about__cmd about__cmd--sep"><span className="txt-green">$</span> cat bio.txt</p>
                            <p className="about__bio">
                                I'm a senior backend &amp; data engineer with 7+ years building scalable,
                                cloud-native systems &mdash; terabyte-scale analytical platforms and production
                                LLM infrastructure. At BrightEdge I architect the data platform behind an
                                AI brand-analytics product: optimizing ClickHouse for terabyte-scale streaming
                                ingestion, running a Trino + Apache Iceberg lakehouse, and serving sub-second
                                analytical APIs. My toolkit spans Python &amp; FastAPI, ClickHouse / Trino /
                                BigQuery, Kubernetes, Terraform and Argo Workflows, plus fine-tuning open-source
                                LLMs on GPU infrastructure. I work remote-first with a documentation-driven,
                                async collaboration style.
                            </p>
                            <a href="#contact" className="btn btn-primary mono">$ contact --now</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About
